import axios from "./axios.js"
import { Notify } from "vant"
import Cookies from "js-cookie"
/**
 * 网络请求-通用
 * @param {String} url  接口地址
 * @param {Object} data  入参
 * @returns
 */
export function post(url, data) {
    return axios({
        url: url,
        method: 'post',
        data: {
            ...data,
            token:Cookies.get("payapp_token")
        },
        timeout: 20000
    }).catch((err) => {
        // console.log(err.response)
        if (err.response) {
            Notify({
                type: "warning",
                message: '接口 ' + err.response.status
            })
        } 
        else if (err.config.timeout > 0) {
            Notify({
                type: "warning",
                message: '请求超时'
            })
        }
    })
}

export function uploadPost(url, params) {
    let config = {
        headers: { 'Content-Type': 'multipart/form-data' }
    }
    return axios({
        url: url,
        method: 'post',
        data:params,
        headers: { 'Content-Type': 'multipart/form-data' },
        config: config,
        timeout: 600000
    }).catch((err) => {
        // console.log(err.response)
        if (err.response) {
            Notify({
                type: "warning",
                message: '接口 ' + err.response.status
            })
        }
         else if (err.config.timeout > 0) {
            Notify({
                type: "warning",
                message: '请求超时'
            })
        }
    })
}

// 跳转查看图片文件
export function look({ fileName = "", filePath = "" }) {
    post('/payment/center/getFileToken', {
        reqData: {
            fileName,
            filePath,
        },
    }).then(res => {
        if (res.repData && res.repData.filePath) {
            var u = navigator.userAgent;
            var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
            var isiOS =u.match(/iphone|ipod|iOS/ig); //IOS端
            if(isiOS){
                window.location.href=res.repData.filePath
            }else{
                window.open(res.repData.filePath)
            }
        }
    })
}